export const loginUrl = ({ search } = {}) =>
  search ? `/login?${search}` : '/login';
